import script from "./DecaWizardStepPackages.vue?vue&type=script&setup=true&lang=js"
export * from "./DecaWizardStepPackages.vue?vue&type=script&setup=true&lang=js"

import "./DecaWizardStepPackages.vue?vue&type=style&index=0&id=ff424f16&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff424f16"]])

export default __exports__